export default "__VITE_ASSET__Ch2yu8aJ__"